import { render, staticRenderFns } from "./FantuanList.vue?vue&type=template&id=0d9432d7&"
import script from "./FantuanList.vue?vue&type=script&lang=js&"
export * from "./FantuanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports